var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8645 23.1777L3.25814 22.125L0.767334 16.8877L10.2488 15.7247L12.8645 23.1777Z",
    fill: "url(#paint0_linear_152_8880)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3885 18.7012L13.1694 23.0532L13.1636 11.9962L22.3837 7.64417L22.3885 18.7012Z",
    fill: "url(#paint1_linear_152_8880)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.94891 18.7012L13.169 23.0532L13.1738 11.9962L3.95469 7.64417L3.94891 18.7012Z",
    fill: "url(#paint2_linear_152_8880)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3814 8.2168L22.3872 10.5737L13.172 15.4517L13.1604 11.4566L22.3814 8.2168Z",
    fill: "url(#paint3_linear_152_8880)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1731 15.4841L3.95306 10.0574L3.94824 8.42712L13.1673 13.4119L13.1731 15.4841Z",
    fill: "url(#paint4_linear_152_8880)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3835 9.86276V9.22904L13.1451 13.1985L3.95203 8.89685V9.35064L13.1673 14.2405L22.3835 9.86276Z",
    fill: "url(#paint5_linear_152_8880)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.28174 5.30212L12.911 10.4935L22.9061 5.92299L13.0208 0.818604L3.28174 5.30212Z",
    fill: "url(#paint6_linear_152_8880)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9108 9.23407L12.9147 13.7492L12.9099 10.4382L22.906 5.9231L22.9108 9.23407Z",
    fill: "url(#paint7_linear_152_8880)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.24506 8.73966L12.9147 13.7491L12.9224 10.4322L3.28164 5.30115L3.24506 8.73966Z",
    fill: "url(#paint8_linear_152_8880)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9147 13.7491L12.9225 10.4322L12.8772 10.4074L22.8531 5.89526L22.906 5.92295V6.20471L13.1227 10.6111L13.1102 13.6621L12.9147 13.7491Z",
    fill: "url(#paint9_linear_152_8880)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5924 2.56657C17.3786 2.48946 16.8741 2.27393 16.2435 2.14739C16.1154 2.12168 15.9979 2.1029 15.8526 2.1286C15.5233 2.18594 15.298 2.42519 15.1044 2.66544C14.676 3.19634 14.4266 3.69956 14.3005 3.95859C14.1166 4.33526 13.8894 4.8197 13.6419 5.39509C13.6284 5.45144 13.6159 5.50681 13.6034 5.55822C13.6034 5.55822 14.2244 4.91757 15.194 4.23936C16.2425 3.50579 18.016 2.90469 18.016 2.90469C17.9121 2.79099 17.7628 2.67631 17.5924 2.56657Z",
    fill: "url(#paint10_linear_152_8880)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1044 2.66549C15.2979 2.42524 15.5223 2.18599 15.8525 2.12865C15.9989 2.10295 16.1154 2.12173 16.2434 2.14743C16.8741 2.27398 17.3786 2.49049 17.5923 2.56662C17.1851 2.30364 16.6517 2.06241 16.2829 1.90818C16.0123 1.79548 15.7062 1.85183 15.4905 2.05747C15.1217 2.40943 14.6885 2.90573 14.3072 3.57504C13.9365 4.22458 13.7593 4.90378 13.6428 5.39514C13.8903 4.82074 14.1175 4.33531 14.3014 3.95864C14.4266 3.69961 14.6759 3.19639 15.1044 2.66549Z",
    fill: "url(#paint11_linear_152_8880)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M15.1044 2.66549C15.2979 2.42524 15.5223 2.18599 15.8525 2.12865C15.9989 2.10295 16.1154 2.12173 16.2434 2.14743C16.8741 2.27398 17.3786 2.49049 17.5923 2.56662C17.1851 2.30364 16.6517 2.06241 16.2829 1.90818C16.0123 1.79548 15.7062 1.85183 15.4905 2.05747C15.1217 2.40943 14.6885 2.90573 14.3072 3.57504C13.9365 4.22458 13.7593 4.90378 13.6428 5.39514C13.8903 4.82074 14.0645 4.32542 14.2484 3.94875C14.3746 3.68873 14.6759 3.19639 15.1044 2.66549Z",
    fill: "url(#paint12_linear_152_8880)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6441 4.15046C17.2738 3.97349 17.58 3.97151 17.735 4.05654C17.9699 4.12475 18.1586 4.31556 18.2915 4.46188C18.3031 4.35511 18.3079 4.25624 18.3117 4.17122C18.3319 3.75599 18.3483 3.1717 18.0181 2.91168C17.7369 2.69023 17.3489 2.80689 16.7635 3.02538C15.9538 3.32692 15.3221 3.76983 14.808 4.21472C14.1764 4.76144 13.5756 5.43768 13.6073 5.55631C13.6256 5.56027 13.6439 5.56521 13.6622 5.57016C13.9155 5.49304 14.989 4.61611 16.6441 4.15046Z",
    fill: "url(#paint13_linear_152_8880)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6188 5.57324C13.6216 5.57386 13.6264 5.57386 13.6302 5.57447C13.6255 5.57386 13.6216 5.57324 13.6188 5.57324Z",
    fill: "url(#paint14_linear_152_8880)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6188 5.57324C13.6216 5.57386 13.6264 5.57386 13.6302 5.57447C13.6255 5.57386 13.6216 5.57324 13.6188 5.57324Z",
    fill: "url(#paint15_linear_152_8880)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7344 4.05664C17.7739 4.07839 17.8047 4.10607 17.8268 4.1387C17.9934 4.37795 17.7806 4.87722 17.538 5.17183C17.1663 5.62365 16.6358 5.70076 16.0668 5.78282C15.4226 5.87674 14.7987 5.75514 14.2229 5.68099C13.8205 5.62958 13.6751 5.58311 13.6298 5.57421C13.626 5.57421 13.6212 5.57421 13.6183 5.57224C13.6144 5.57224 13.6116 5.57323 13.6116 5.5752C13.5971 5.63452 15.1338 6.49761 16.6811 6.13675C17.0238 6.05667 17.6314 5.9064 18.0011 5.3399C18.1956 5.04232 18.262 4.72595 18.2899 4.46001C18.159 4.31567 17.9693 4.12585 17.7344 4.05664Z",
    fill: "url(#paint16_linear_152_8880)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M17.7344 4.05664C17.7739 4.07839 17.8047 4.10607 17.8268 4.1387C17.9934 4.37795 17.7806 4.87722 17.538 5.17183C17.1663 5.62365 16.6358 5.70076 16.0668 5.78282C15.4226 5.87674 14.7987 5.75514 14.2229 5.68099C13.8205 5.62958 13.6751 5.58311 13.6298 5.57421C13.626 5.57421 13.6212 5.57421 13.6183 5.57224C13.6144 5.57224 13.6116 5.57323 13.6116 5.5752C13.5971 5.63452 15.1338 6.49761 16.6811 6.13675C17.0238 6.05667 17.6314 5.9064 18.0011 5.3399C18.1956 5.04232 18.262 4.72595 18.2899 4.46001C18.159 4.31567 17.9693 4.12585 17.7344 4.05664Z",
    fill: "url(#paint17_linear_152_8880)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6188 5.57185C13.6217 5.57185 13.6255 5.57276 13.6304 5.57367C13.639 5.57367 13.6487 5.57276 13.6612 5.56913C13.6429 5.56458 13.6246 5.56003 13.6063 5.5564C13.6072 5.55912 13.6063 5.56367 13.6082 5.56549C13.612 5.56913 13.6149 5.57095 13.6188 5.57185Z",
    fill: "url(#paint18_linear_152_8880)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6188 5.57185C13.6217 5.57185 13.6255 5.57276 13.6304 5.57367C13.639 5.57367 13.6487 5.57276 13.6612 5.56913C13.6429 5.56458 13.6246 5.56003 13.6063 5.5564C13.6072 5.55912 13.6063 5.56367 13.6082 5.56549C13.612 5.56913 13.6149 5.57095 13.6188 5.57185Z",
    fill: "url(#paint19_linear_152_8880)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2493 5.55731C13.2378 5.5059 13.2243 5.45153 13.2108 5.39418C13.1097 4.96511 12.9605 4.3917 12.6774 3.82026C12.479 3.47917 12.1941 3.06592 11.7848 2.66947C11.4007 2.29774 11.1138 2.06244 10.8827 2.01993C10.6969 1.98632 10.0672 2.23249 9.64833 2.50239C9.51546 2.5884 9.30749 2.73176 9.06004 2.92158C9.04368 2.93443 9.02827 2.95025 9.0119 2.96508C9.48465 3.13611 10.8095 3.64329 11.6587 4.23747C12.6283 4.91667 13.2493 5.55731 13.2493 5.55731Z",
    fill: "url(#paint20_linear_152_8880)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64888 2.50225C10.0677 2.23334 10.6974 1.98617 10.8832 2.01979C11.1143 2.0623 11.4012 2.2976 11.7854 2.66933C12.1946 3.06578 12.4796 3.47903 12.6779 3.82011C12.6375 3.73806 12.5942 3.656 12.547 3.57394C12.1657 2.90463 11.7324 2.40833 11.3637 2.05637C11.148 1.85073 10.8418 1.79438 10.5713 1.90708C10.2025 2.06131 9.6691 2.30254 9.26183 2.56552C9.09141 2.67625 8.94217 2.78994 8.83722 2.90265C8.83722 2.90265 8.90173 2.9244 9.01245 2.96494C9.02882 2.95011 9.04423 2.93429 9.06059 2.92143C9.30804 2.73161 9.51601 2.58826 9.64888 2.50225Z",
    fill: "url(#paint21_linear_152_8880)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64888 2.50225C10.0677 2.23334 10.6974 1.98617 10.8832 2.01979C11.1143 2.0623 11.4012 2.2976 11.7854 2.66933C12.1946 3.06578 12.4796 3.47903 12.6779 3.82011C12.6375 3.73806 12.5942 3.656 12.547 3.57394C12.1657 2.90463 11.7324 2.40833 11.3637 2.05637C11.148 1.85073 10.8418 1.79438 10.5713 1.90708C10.2025 2.06131 9.6691 2.30254 9.26183 2.56552C9.09141 2.67625 8.94217 2.78994 8.83722 2.90265C8.83722 2.90265 8.90173 2.9244 9.01245 2.96494C9.02882 2.95011 9.04423 2.93429 9.06059 2.92143C9.30804 2.73161 9.51601 2.58826 9.64888 2.50225Z",
    fill: "url(#paint22_linear_152_8880)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2104 4.15046C9.58073 3.97349 9.27455 3.97151 9.11953 4.05654C8.8846 4.12475 8.69589 4.31556 8.56302 4.46188C8.55147 4.35511 8.54665 4.25624 8.5428 4.17122C8.52258 3.75599 8.50621 3.1717 8.83646 2.91168C9.11761 2.69023 9.50563 2.80689 10.091 3.02538C10.9008 3.32692 11.5324 3.76983 12.0465 4.21472C12.6782 4.76144 13.279 5.43768 13.2472 5.55631C13.2289 5.56027 13.2106 5.56521 13.1923 5.57016C12.9381 5.49304 11.8646 4.61611 10.2104 4.15046Z",
    fill: "url(#paint23_linear_152_8880)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2345 5.57324C13.2317 5.57386 13.2269 5.57386 13.2231 5.57447C13.2279 5.57386 13.2317 5.57324 13.2345 5.57324Z",
    fill: "url(#paint24_linear_152_8880)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2345 5.57324C13.2317 5.57386 13.2269 5.57386 13.2231 5.57447C13.2279 5.57386 13.2317 5.57324 13.2345 5.57324Z",
    fill: "url(#paint25_linear_152_8880)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11958 4.05664C9.0801 4.07839 9.04929 4.10607 9.02715 4.1387C8.86058 4.37795 9.07336 4.87722 9.316 5.17183C9.68765 5.62365 10.2182 5.70076 10.7872 5.78282C11.4313 5.87674 12.0552 5.75514 12.631 5.68099C13.0335 5.62958 13.1789 5.58311 13.2241 5.57421C13.228 5.57421 13.2328 5.57421 13.2357 5.57224C13.2395 5.57224 13.2424 5.57323 13.2424 5.5752C13.2569 5.63452 11.7202 6.49761 10.1729 6.13675C9.83015 6.05667 9.2226 5.9064 8.85287 5.3399C8.65838 5.04232 8.59195 4.72595 8.56403 4.46001C8.69593 4.31567 8.88465 4.12585 9.11958 4.05664Z",
    fill: "url(#paint26_linear_152_8880)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M9.11958 4.05664C9.0801 4.07839 9.04929 4.10607 9.02715 4.1387C8.86058 4.37795 9.07336 4.87722 9.316 5.17183C9.68765 5.62365 10.2182 5.70076 10.7872 5.78282C11.4313 5.87674 12.0552 5.75514 12.631 5.68099C13.0335 5.62958 13.1789 5.58311 13.2241 5.57421C13.228 5.57421 13.2328 5.57421 13.2357 5.57224C13.2395 5.57224 13.2424 5.57323 13.2424 5.5752C13.2569 5.63452 11.7202 6.49761 10.1729 6.13675C9.83015 6.05667 9.2226 5.9064 8.85287 5.3399C8.65838 5.04232 8.59195 4.72595 8.56403 4.46001C8.69593 4.31567 8.88465 4.12585 9.11958 4.05664Z",
    fill: "url(#paint27_linear_152_8880)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2348 5.57185C13.2319 5.57185 13.228 5.57276 13.2232 5.57367C13.2146 5.57367 13.2049 5.57276 13.1924 5.56913C13.2107 5.56458 13.229 5.56003 13.2473 5.5564C13.2464 5.55912 13.2473 5.56367 13.2454 5.56549C13.2425 5.56913 13.2386 5.57095 13.2348 5.57185Z",
    fill: "url(#paint28_linear_152_8880)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2348 5.57185C13.2319 5.57185 13.228 5.57276 13.2232 5.57367C13.2146 5.57367 13.2049 5.57276 13.1924 5.56913C13.2107 5.56458 13.229 5.56003 13.2473 5.5564C13.2464 5.55912 13.2473 5.56367 13.2454 5.56549C13.2425 5.56913 13.2386 5.57095 13.2348 5.57185Z",
    fill: "url(#paint29_linear_152_8880)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8413 20.376L17.5241 20.9988V8.30856L18.8413 7.7124V20.376Z",
    fill: "url(#paint30_linear_152_8880)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M14.278 5.24882C14.2501 5.24388 14.2232 5.23992 14.1952 5.23795L13.5617 5.19543L13.2401 5.76984L17.5237 8.30868L18.8409 7.71154L14.6584 5.3556C14.5881 5.31704 14.4109 5.27057 14.278 5.24882Z",
    fill: "url(#paint31_linear_152_8880)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8427 7.70654L18.7722 7.73743L18.778 7.74041L18.8427 7.70654Z",
    fill: "url(#paint32_linear_152_8880)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8165 5.33677C14.3553 5.08368 13.5764 5.12421 13.5764 5.12421L13.561 5.19539L14.1945 5.23791C14.2224 5.23988 14.2494 5.24384 14.2773 5.24878C14.4092 5.27053 14.5873 5.317 14.6576 5.35654L18.7708 7.73721L18.8411 7.71249C18.8421 7.71249 15.6667 5.80341 14.8165 5.33677Z",
    fill: "url(#paint33_linear_152_8880)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8165 5.33677C14.3553 5.08368 13.5764 5.12421 13.5764 5.12421L13.561 5.19539L14.1945 5.23791C14.2224 5.23988 14.2494 5.24384 14.2773 5.24878C14.4092 5.27053 14.6008 5.33578 14.6711 5.37533L18.7737 7.74314L18.8392 7.71249C18.8411 7.7115 15.6667 5.80341 14.8165 5.33677Z",
    fill: "url(#paint34_linear_152_8880)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6031 8.27401L13.4379 5.77174L13.204 5.60071L13.2502 5.7757L17.5242 8.3096L17.6031 8.27401Z",
    fill: "url(#paint35_linear_152_8880)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2681 5.20121C12.297 5.19824 12.3258 5.19527 12.3557 5.19428L13.0181 5.17847C13.1876 5.17946 13.331 5.29612 13.3638 5.45034C13.3898 5.57096 13.3445 5.69948 13.2492 5.7855C11.7077 6.57246 10.1653 7.35942 8.62377 8.14638L7.38654 7.50772L11.8637 5.29315C11.9398 5.25657 12.1285 5.21702 12.2681 5.20121Z",
    fill: "url(#paint36_linear_152_8880)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31616 7.47327L7.38674 7.50813L7.38086 7.51112L7.31616 7.47327Z",
    fill: "url(#paint37_linear_152_8880)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7006 5.26652C12.2012 5.03221 13.0071 5.10635 13.0071 5.10635L13.0168 5.17853L12.3543 5.19434C12.3254 5.19533 12.2966 5.1983 12.2667 5.20126C12.1281 5.21708 11.923 5.27442 11.846 5.31199L7.41309 7.50778L7.31488 7.45044C7.31584 7.44945 10.7772 5.69855 11.7006 5.26652Z",
    fill: "url(#paint38_linear_152_8880)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M8.508 8.08324C9.37262 7.62748 10.0293 7.31309 10.4702 7.07878C11.1298 6.72781 11.7585 6.41737 12.4671 6.06443C12.7656 5.91613 12.9553 5.82913 13.1305 5.74905C13.1825 5.72631 13.2403 5.6927 13.3173 5.58691C13.3366 5.56022 13.3241 5.67885 13.325 5.68874C13.3279 5.71445 13.3173 5.76981 13.1113 5.85582L8.62546 8.14652L8.508 8.08324Z",
    fill: "url(#paint39_linear_152_8880)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23431 20.2525L8.61694 20.9059L8.6256 8.14449L7.31616 7.44849L7.23431 20.2525Z",
    fill: "url(#paint40_linear_152_8880)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9199 5.43966C12.7321 5.23896 12.6329 4.97994 12.6233 4.71399C12.6031 4.12673 12.5521 2.61114 12.5704 2.30762C12.5925 1.92897 12.7157 1.59184 13.1394 1.61261C13.563 1.63337 13.77 1.91315 13.798 2.17317C13.8211 2.39265 13.8374 4.22066 13.8413 4.7832C13.8423 4.90183 13.8163 5.01849 13.7633 5.12626C13.6352 5.38726 13.3695 5.82029 13.0884 5.59586C13.0248 5.54347 12.968 5.49107 12.9199 5.43966Z",
    fill: "url(#paint41_linear_152_8880)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_8880",
    x1: 13.9213,
    y1: 20.6624,
    x2: -0.927831,
    y2: 17.6956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1757
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8244,
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_152_8880",
    x1: 17.7736,
    y1: 9.81993,
    x2: 22.043,
    y2: 18.8647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#090606",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_152_8880",
    x1: 7.04639,
    y1: 8.19203,
    x2: 10.0986,
    y2: 21.8654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0179,
    stopColor: "#1B1E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0F151A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_152_8880",
    x1: 15.6782,
    y1: 8.93397,
    x2: 19.8594,
    y2: 14.4155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#090808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2402,
    stopColor: "#393434",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_152_8880",
    x1: 4.73617,
    y1: 6.44866,
    x2: 14.3099,
    y2: 18.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4796,
    stopColor: "#140D0D",
    stopOpacity: 0.8119
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#252728",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_152_8880",
    x1: 9.02277,
    y1: 3.56065,
    x2: 19.2289,
    y2: 16.9409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#141111",
    stopOpacity: 0.7889
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2C2C",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_152_8880",
    x1: 20.2316,
    y1: 8.41723,
    x2: 7.20352,
    y2: 3.72126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0179,
    stopColor: "#F0F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2832,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7041,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8793,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_152_8880",
    x1: 17.9127,
    y1: 11.2934,
    x2: 16.8522,
    y2: 8.98886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0179,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#E2E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8901,
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#787979"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_152_8880",
    x1: 8.07872,
    y1: 11.3721,
    x2: 9.59725,
    y2: 8.86505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0179,
    stopColor: "#848687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7358,
    stopColor: "#A2A4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F9091"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_152_8880",
    x1: 13.1317,
    y1: 6.9061,
    x2: 20.9388,
    y2: 11.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#737676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#BDBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FBFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9047,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9048,
    stopColor: "#888B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#DCDFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_152_8880",
    x1: 15.961,
    y1: 5.12788,
    x2: 15.3826,
    y2: 1.95113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0179,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9289,
    stopColor: "#9C67DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_152_8880",
    x1: 15.8139,
    y1: 5.15471,
    x2: 15.2355,
    y2: 1.97796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0179,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9289,
    stopColor: "#8F5BD0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_152_8880",
    x1: 15.3153,
    y1: 3.5298,
    x2: 14.4217,
    y2: 2.35166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6515CA",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2975,
    stopColor: "#6515CA",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7776,
    stopColor: "#6515CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_152_8880",
    x1: 19.0683,
    y1: 3.01843,
    x2: 13.4099,
    y2: 5.36259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3738,
    stopColor: "#812CEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6096,
    stopColor: "#6A1ACD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6202,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8292,
    stopColor: "#460A92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42048E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_152_8880",
    x1: 19.0268,
    y1: 3.9969,
    x2: 14.4484,
    y2: 7.01484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A261F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    stopColor: "#8D48E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3738,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6096,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6202,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8292,
    stopColor: "#441284"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#440493"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_152_8880",
    x1: 13.8139,
    y1: 6.28356,
    x2: 13.6306,
    y2: 4.68157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0179,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#8138DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9289,
    stopColor: "#8543D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_152_8880",
    x1: 19.437,
    y1: 3.90765,
    x2: 13.7786,
    y2: 6.25184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F48C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    stopColor: "#9552E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3737,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#7622DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6096,
    stopColor: "#4F1993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8292,
    stopColor: "#510EA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A0B75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_152_8880",
    x1: 18.4629,
    y1: 4.97414,
    x2: 11.9488,
    y2: 5.64247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0203,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5558,
    stopColor: "#7F33DE",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5893,
    stopColor: "#8031E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_152_8880",
    x1: 19.081,
    y1: 3.2384,
    x2: 13.566,
    y2: 5.72509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3738,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6096,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6202,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8292,
    stopColor: "#5818A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#320768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_152_8880",
    x1: 13.8263,
    y1: 6.61698,
    x2: 13.4371,
    y2: 4.29004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0179,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#9149EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9289,
    stopColor: "#8D48E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_152_8880",
    x1: 13.0593,
    y1: 4.55255,
    x2: 9.44286,
    y2: 2.24503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1526,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9289,
    stopColor: "#9861DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_152_8880",
    x1: 13.0983,
    y1: 4.49063,
    x2: 9.48187,
    y2: 2.18312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1526,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9289,
    stopColor: "#9C67DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_152_8880",
    x1: 12.5965,
    y1: 4.15303,
    x2: 9.16903,
    y2: 1.96609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#491787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#5D21A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7776,
    stopColor: "#8632EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_152_8880",
    x1: 7.78564,
    y1: 3.01842,
    x2: 13.444,
    y2: 5.36258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#8B51D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6202,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8292,
    stopColor: "#480C94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34076B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_152_8880",
    x1: 7.82692,
    y1: 3.99691,
    x2: 12.4053,
    y2: 7.01484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3738,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6096,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6202,
    stopColor: "#441481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8292,
    stopColor: "#420E83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E0B5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_152_8880",
    x1: 13.0398,
    y1: 6.28356,
    x2: 13.2231,
    y2: 4.68158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#7826DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9289,
    stopColor: "#9055DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_152_8880",
    x1: 7.41731,
    y1: 3.90766,
    x2: 13.0757,
    y2: 6.25183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3738,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6096,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6202,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8292,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6515CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_152_8880",
    x1: 8.3914,
    y1: 4.97415,
    x2: 14.9055,
    y2: 5.64248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A980DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#6515CA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#6515CA",
    stopOpacity: 0.06
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_152_8880",
    x1: 7.77202,
    y1: 3.23811,
    x2: 13.2879,
    y2: 5.72533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3738,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6096,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6202,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8292,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#380E6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_152_8880",
    x1: 13.0276,
    y1: 6.61705,
    x2: 13.4169,
    y2: 4.28994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0179,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8753,
    stopColor: "#BF99EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9289,
    stopColor: "#AD7EE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_152_8880",
    x1: 18.6013,
    y1: 20.6808,
    x2: 17.7008,
    y2: 7.77685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0179,
    stopColor: "#752FCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4772,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5532,
    stopColor: "#7724DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7298,
    stopColor: "#8028ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8601,
    stopColor: "#9B52F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9289,
    stopColor: "#A865FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_152_8880",
    x1: 17.151,
    y1: 8.81491,
    x2: 14.2991,
    y2: 3.76519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF7AF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#A76DF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#9A5DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#8F54D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#935AD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#833CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#5B2B97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8461,
    stopColor: "#390A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#320C63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_152_8880",
    x1: 18.8699,
    y1: 7.83681,
    x2: 15.9185,
    y2: 2.55672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8EC7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1736,
    stopColor: "#F7E977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3702,
    stopColor: "#F4DF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5779,
    stopColor: "#EFD053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#E8BA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7955,
    stopColor: "#E8BA33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_152_8880",
    x1: 17.3902,
    y1: 8.67274,
    x2: 14.542,
    y2: 3.62961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8EC7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546,
    stopColor: "#F7E977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1165,
    stopColor: "#F4DF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1818,
    stopColor: "#EFD053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2492,
    stopColor: "#E8BA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2503,
    stopColor: "#E8BA33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#E1AB2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4934,
    stopColor: "#CE851E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6202,
    stopColor: "#BD6211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8461,
    stopColor: "#A14A0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#933E08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_152_8880",
    x1: 16.2001,
    y1: 5.12183,
    x2: 16.2001,
    y2: 7.74314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#4C1097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#6515CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_152_8880",
    x1: 15.4036,
    y1: 5.60071,
    x2: 15.4036,
    y2: 8.3096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6515CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_152_8880",
    x1: 9.05893,
    y1: 8.87714,
    x2: 12.7485,
    y2: 3.71689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A36FE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#8550C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#6C28C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4682,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#5A2A95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7649,
    stopColor: "#4B168D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#330967"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_152_8880",
    x1: 7.23311,
    y1: 7.69715,
    x2: 13.5681,
    y2: -1.25455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8EC7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1736,
    stopColor: "#F7E977"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3702,
    stopColor: "#F4DF6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5779,
    stopColor: "#EFD053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7921,
    stopColor: "#E8BA34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7955,
    stopColor: "#E8BA33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_152_8880",
    x1: 10.1658,
    y1: 5.09521,
    x2: 10.1658,
    y2: 7.50778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#6515CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_152_8880",
    x1: 10.9181,
    y1: 5.58301,
    x2: 10.9181,
    y2: 8.14652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#320A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6515CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_152_8880",
    x1: 7.54268,
    y1: 20.5848,
    x2: 8.45488,
    y2: 7.51311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0179,
    stopColor: "#370378"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2398,
    stopColor: "#3B0B76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4057,
    stopColor: "#580EB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5058,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7022,
    stopColor: "#8636EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8842,
    stopColor: "#9853EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A05FF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_152_8880",
    x1: 13.2043,
    y1: 1.6114,
    x2: 13.2043,
    y2: 5.6578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9143F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#8A3AEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297186,
    stopColor: "#7118DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399462,
    stopColor: "#7619EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512503,
    stopColor: "#6515CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639899,
    stopColor: "#5E13BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7465,
    stopColor: "#5312A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8934,
    stopColor: "#390C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D1A8C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.5b8fe8250f85a4d34973b309df3356d1.svg";
export { ForwardRef as ReactComponent };